<template>
    <div>
        <div class="layout">
            <div class="layout__header">
                <div class="card__title">
                    <h3>Detalle de guía de remisión</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                        <div class="form-group">
                            <input-field v-model="modelValue.numero_documento" readonly id="numero_documento" placeholder="###-###-#########">
                                Documento de sustento
                            </input-field>
                            <button v-show="!comprobanteSeleccionado" @click="consultarComprobantes" class="btn-info" type="button"><i class="fa fa-search"></i></button>
                            <button v-show="comprobanteSeleccionado" @click="quitarComprobante" class="btn-danger" type="button"><i class="fa fa-ban"></i></button>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                        <input-field v-model="modelValue.fecha_emision_doc" id="fechaEmisionSustento" placeholder="YYYY-MM-DD" readonly>
                            Fecha de emisión de documento
                        </input-field>    
                    </div>
                </div>
                <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                        <input-field :tooltip="modelValue.numero_aut_documento!==''?modelValue.numero_aut_documento:'Digite...'" v-model="modelValue.numero_aut_documento" id="numero_aut_documento" placeholder="##########" readonly>
                            Número de autorización del documento
                        </input-field>
                    </div>
                </div>
                <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                        <div class="form-group">
                            <input-field v-model="modelValue.identificacion_destinatario" id="identificacionDestinatario" placeholder="Id destinatario">
                                Identificación del destinatario
                            </input-field>
                            <button @click="consultarCliente" v-show="!destinatarioSeleccionado" class="btn-success" type="button"><i class="fa fa-check"></i></button>
                            <button @click="quitarPersona" v-show="destinatarioSeleccionado" class="btn-danger" type="button"><i class="fa fa-ban"></i></button>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                        <div class="form-group">
                            <input-field :tooltip="modelValue.nombre_destinatario!==''?modelValue.nombre_destinatario:'Seleccione...'" readonly id="nombreDestinatario" placeholder="Nombre o Razón social" v-model="modelValue.nombre_destinatario">
                                Nombre del destinatario
                            </input-field>
                            <button @click="$modal.show('listaDestinatarios')" class="btn-info" type="button"><i class="fa fa-search"></i></button>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                        <input-field :tooltip="modelValue.direccion_destinatario!==''?modelValue.direccion_destinatario:'Digite...'"  v-model="modelValue.direccion_destinatario" id="direccionDestinatario" placeholder="Dirección o referencia">
                            Dirección del destinatario
                        </input-field>
                    </div>
                </div>
                <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                        <input-field readonly id="codigoEstablecimiento" v-model="modelValue.cod_establecimiento" placeholder="###">
                            Código de establecimiento
                        </input-field>
                    </div>
                </div>
                <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                        <input-field :tooltip="modelValue.motivo_traslado!==''?modelValue.motivo_traslado:'Digite...'" id="motivoTraslado" v-model="modelValue.motivo_traslado" placeholder="Motivo">
                            Motivo del traslado
                        </input-field>
                    </div>
                </div>
                <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                        <input-field v-mask="'XXXXXXXXXXXXXXXXXXXX'" id="documentoAduanero" v-model="modelValue.documento_aduanero" placeholder="####">
                            Documento aduanero
                        </input-field>
                    </div>
                </div>
                <div class="col-xs-12 col-md-6">
                    <div class="form-field">
                        <input-field :tooltip="modelValue.ruta!==''?modelValue.ruta:'Digite...'" v-model="modelValue.ruta" id="ruta" placeholder="Ruta del destino">
                            Ruta
                        </input-field>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <h5>Ítems</h5>
                    <tabla-item-guia-remision :idComprobante="modelValue.id_comprobante" v-model="modelValue.detalles"></tabla-item-guia-remision>
                </div>
            </div>
            <div class="modal-buttons">
                <button @click="$emit('cancelar')" class="btn-danger btn--text" type="button"><i class="fa fa-ban"></i><span>Cancelar</span></button>
                <button @click="aceptar" class="btn-success" type="button"><i class="fa fa-check"></i><span>Aceptar</span></button>
            </div>
        </div>
        <modal name="listaComprobantesVenta" width="70%" height="auto" scrollable>
            <lista-comprobantes @selected="selectedComprobante"></lista-comprobantes>
        </modal>
        <modal name="listaDestinatarios" width="70%" height="auto" scrollable>
            <lista-personas :filterStatus="false" @selected="selectedPersona" :createButton="false"></lista-personas>
        </modal>
        <modal scrollable width="70%" height="auto" name="destinatario">
            <persona :numeroIdentificacion="modelValue.identificacion_destinatario" @saved="savedPersona" :searchButton="false"></persona>
        </modal>
    </div>
</template>

<script>
export default {
    props : {
        value : {
            type : Object,
            required : false,
            default : function () {
                return {
                    id_destinatario : '',
                    identificacion_destinatario : '',
                    nombre_destinatario : '',
                    direccion_destinatario : '',
                    motivo_traslado : '',
                    documento_aduanero : '',
                    cod_establecimiento : '',
                    ruta : '',
                    cod_doc_sustento : '',
                    numero_documento : '',
                    numero_aut_documento : '', 
                    fecha_emision_doc : '',
                    detalles : [],
                    id_comprobante : '',
                    email : '',
                    telefono : ''
                };
            }
        },
        detallesActuales : {
            type : Array,
            required : true
        }
    },
    data : function () {
        return {
            modelValue : this.value,
            url : url,
            personaSeleccionada : null,
            emailAnterior : this.value.email,
            telefonoAnterior : this.value.telefono
        };
    },
    computed : {
        destinatarioSeleccionado : function () {
            return this.modelValue.id_destinatario !== '';
        },
        comprobanteSeleccionado : function () {
            return this.modelValue.id_comprobante !== '';
        }
    },
    methods : {
        existeComprobante : function (idComprobante) {
            for (let i = 0; i < this.detallesActuales.length; i++)
                if (this.detallesActuales[i].id_comprobante === idComprobante)
                    return true;
            return false;
        },
        quitarComprobante : function () {
            this.modelValue.numero_documento = '';
            this.modelValue.cod_doc_sustento = '';
            this.modelValue.detalles = [];
            this.modelValue.id_comprobante = '';
            this.modelValue.fecha_emision_doc = '';
            this.modelValue.numero_aut_documento = '';
            this.modelValue.identificacion_destinatario = '';
            this.modelValue.nombre_destinatario = '';
            this.modelValue.direccion_destinatario = '';
            this.modelValue.id_destinatario = '';
            this.modelValue.cod_establecimiento = '';
            this.modelValue.email = '';
            this.modelValue.telefono = '';
        },
        aceptar : function () {
            if (this.modelValue.detalles.length === 0)
                swal('Debe agregar al menos un detalle.', 'Mensaje', 'warning');
            else if (this.modelValue.id_destinatario === '')
                swal('El destinatario es requerido.', 'Mensaje', 'warning');
            else if (this.modelValue.direccion_destinatario === '')
                swal('La dirección del destinatario es requerida.', 'Mensaje', 'warning');
            else if (this.modelValue.motivo_traslado === '') 
                swal('El motivo de traslado es requerido.', 'Mensaje', 'warning');
            else 
            {
                if (this.modelValue.email !== undefined && this.modelValue.email !== null && this.modelValue.email !== '' && this.emailAnterior !== this.modelValue.email)
                    this.$emit('personaActualizada', this.emailAnterior, this.telefonoAnterior);
                this.$emit('input', this.modelValue);
            }
        },
        consultarComprobantes : function () {
            this.$modal.show('listaComprobantesVenta');
        },
        selectedComprobante : function (comprobante) {
            if (!this.existeComprobante(comprobante.id_comprobante)) {
                this.modelValue.numero_documento = comprobante.numero_documento;
                this.modelValue.cod_doc_sustento = comprobante.id_tipo_comprobante;
                this.modelValue.detalles = [];
                this.modelValue.id_comprobante = comprobante.id_comprobante;
                this.modelValue.fecha_emision_doc = moment(new Date(comprobante.fecha_emision)).format('YYYY-MM-DD');
                this.modelValue.numero_aut_documento = comprobante.numero_autorizacion;
                this.modelValue.identificacion_destinatario = comprobante.numero_identificacion;
                this.modelValue.nombre_destinatario = comprobante.nombre_cliente;
                this.modelValue.direccion_destinatario = comprobante.direccion_cliente;
                this.modelValue.id_destinatario = comprobante.id_persona;
                this.modelValue.cod_establecimiento = comprobante.codigo_establecimiento;
                this.modelValue.email = comprobante.correo_cliente;
                this.$modal.hide('listaComprobantesVenta');
            }
            else 
                swal('El comprobante ya ha sido agregado como detalle.', 'Mensaje', 'warning');
        },
        selectedPersona : function (persona) {
            this.modelValue.id_destinatario = persona.id;
            this.modelValue.identificacion_destinatario = persona.identificacion;
            this.modelValue.nombre_destinatario = persona.nombre;
            this.modelValue.direccion_destinatario = persona.direccion;
            this.modelValue.personaSeleccionada = persona;
            this.modelValue.email = persona.email;
            this.modelValue.telefono = persona.telefono;
            this.$modal.hide('listaDestinatarios');
        },
        savedPersona : function (persona) {
            this.$modal.hide('destinatario');
            this.selectedPersona(persona);
        },
        consultarCliente : function() {
            if (this.numero_identificacion !== '') {
                let that = this;
                axios.get(this.url + '/personas/' + this.modelValue.identificacion_destinatario).then(function (response) {
                    that.selectedPersona(response.data);
                }).catch(function (error) {
                    if (error !== undefined && error !== null) {
                        let response = error.response;
                        if (response !== undefined && response !== null) {
                            let status = response.status;
                            if (status === 404) {
                                swal({
                                    title: '¿Desear crear una nueva persona?',
                                    text: "Esta acción requiere de confirmación.",
                                    type: 'question',
                                    showCancelButton: true,
                                    confirmButtonText: 'Nueva persona',
                                    cancelButtonText : 'No'
                                }).then((result) => {
                                    if (result.value)
                                        that.crearNuevaPersona();                 
                                });
                            }
                            else 
                                swal('Hubo un error al momento de consultar el número. Intente nuevamente.', 'Error', 'error');
                        }
                    }
                });
            }
            else 
                swal('Debe ingresar un número de identificación.', 'Aviso', 'warning');
        },
        quitarPersona : function () {
            this.modelValue.id_destinatario = '';
            this.modelValue.nombre_destinatario = '';
            this.modelValue.direccion_destinatario = '';
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/DetalleGuiaRemision.vue